let subscribers={};function subscribe(s,r){return void 0===subscribers[s]&&(subscribers[s]=[]),subscribers[s]=[...subscribers[s],r],function(){subscribers[s]=subscribers[s].filter(s=>s!==r)}}function publish(s,r){subscribers[s]&&subscribers[s].forEach(s=>{s(r)})}

// let subscribers = {};

// function subscribe(eventName, callback) {
//   if (subscribers[eventName] === undefined) {
//     subscribers[eventName] = [];
//   }

//   subscribers[eventName] = [...subscribers[eventName], callback];

//   return function unsubscribe() {
//     subscribers[eventName] = subscribers[eventName].filter((cb) => {
//       return cb !== callback;
//     });
//   };
// }

// function publish(eventName, data) {
//   if (subscribers[eventName]) {
//     subscribers[eventName].forEach((callback) => {
//       callback(data);
//     });
//   }
// }
